import CountUp from 'react-countup';

import { Section, SectionHeader } from '@/components/atomic/nuclei';

const provenAtScaleData = [
  {
    count: 20000,
    description: 'across the UAE',
    title: 'Events Delivered'
  },
  {
    count: 5000,
    description: '(summits, offsites, galas, product launches)',
    title: 'Corporate Events'
  },
  {
    count: 1000,
    description: '(intimate ceremonies to multi-day celebrations)',
    title: 'Weddings'
  }
];

const ProvenAtScale = () => (
  <>
    <Section>
      <SectionHeader
        gradientText='at Scale'
        text='Proven'
      />
      <div className='grid grid-cols-1 gap-6 lg:grid-cols-3'>
        {provenAtScaleData.map(({ count, description, title }, index) => (
          <div
            key={index}
            className='bg-white rounded-xl shadow-md p-8 text-center border border-pink-100 hover:border-pink-200 hover:shadow-xl transition-all ease-in-out cursor-pointer'
          >
            <div className='text-5xl md:text-7xl font-extrabold mb-2 bg-control bg-clip-text text-transparent font-Montserrat'>
              <CountUp
                end={count}
                separator=','
                duration={2}
              />
              +
            </div>
            <div className='text-xl md:text-2xl font-bold'>{title}</div>
            <div className='text-gray-500 text-base'>{description}</div>
          </div>
        ))}
      </div>
    </Section>
    <div className='border-t border-pink-100 container mx-auto' />
  </>
);

export default ProvenAtScale;
